import { push } from 'react-router-redux';
import { submitAddress } from '../../helpers/api/verifications';
import { OnfidoAddress } from 'src/helpers/api/addresses';

const ADDRESS_VERIFICATION_REQUEST = 'ADDRESS_VERIFICATION_REQUEST';
const ADDRESS_VERIFICATION_SUCCESS = 'ADDRESS_VERIFICATION_SUCCESS';
const ADDRESS_VERIFICATION_FAILURE = 'ADDRESS_VERIFICATION_FAILURE';

export type AddressVerificationData = {
  address: OnfidoAddress;
  dateOfBirth: string;
  firstName: string;
  lastName: string;
  pageId: string;
  pageName: string;
  phoneNumber?: string;
  title?: string;
};

export function verifyAddress(data: AddressVerificationData) {
  return async (dispatch: any) => {
    try {
      dispatch({ type: ADDRESS_VERIFICATION_REQUEST, payload: data });

      const payload = {
        projectId: data.pageId,
        addressLine1: data.address.addressLine1,
        addressLine2: data.address.addressLine2,
        town: data.address.town,
        postCode: data.address.postCode,
      };

      const result = await submitAddress(payload);

      if (result.verified) {
        dispatch({ type: ADDRESS_VERIFICATION_SUCCESS, payload: result });
        dispatch({
          type: 'UPDATE_SUCCESS',
          payload: { verificationStatus: 'AddressVerificationPending' },
        });
        dispatch(push(`/${data.pageName}`));
      } else if (result.message === 'approvalNeeded') {
        dispatch({
          type: ADDRESS_VERIFICATION_FAILURE,
          error: true,
          payload: result,
        });
        dispatch(push(`/${data.pageName}`));
      } else {
        dispatch({
          type: ADDRESS_VERIFICATION_FAILURE,
          error: true,
          payload: result,
        });
      }
    } catch (error) {
      dispatch({
        type: ADDRESS_VERIFICATION_FAILURE,
        error: true,
        payload: { message: 'serverError', error },
      });
    }
  };
}

export default function reducer(
  state = {
    serverErrorMessage: null,
  },
  action: {
    type: string;
    payload: {
      message: string;
      error?: Error;
    };
  }
) {
  switch (action.type) {
    case ADDRESS_VERIFICATION_REQUEST:
      return { ...state, isProcessing: true, serverErrorMessage: null };
    case ADDRESS_VERIFICATION_SUCCESS:
      return { ...state, isProcessing: false };
    case ADDRESS_VERIFICATION_FAILURE:
      return {
        ...state,
        isProcessing: false,
        serverErrorMessage: action.payload.message,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/addressVerification.ts